































import mixins from 'vue-typed-mixins';
import _ from 'lodash';
import { editName } from '@/main/store/listEditTypes';

import { UserRole } from '@/main/components/constants';

import { Tabs } from '../../components';
import EditLayout from '../../EditLayout.vue';
import WorkflowButtons from '../../components/WorkflowButtons.vue';
import { EditMixin } from '../../mixins/editMixin';
import { NAME } from './constants';
import HlavniKarta from './HlavniKarta.vue';
import { MENU_CODE, TAB_NAMES, TABS } from '../../constants';
import VozidloSelect from '../../components/microcomponents/VozidloSelect.vue';
import ZakaznikSelect from '../../components/microcomponents/ZakaznikSelect.vue';

export default mixins(EditMixin).extend({
	name: editName(NAME),
	components: {
		VozidloSelect,
		ZakaznikSelect,
		HlavniKarta,
		EditLayout,
		Tabs,
		WorkflowButtons,
	},
	computed: {
		// TODO: ověřit zda se mají zobrazovat fakturační texty v poznámmkách
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(MENU_CODE, TABS.AddvancePay)) tabItems.push(TAB_NAMES.ADVANCEPAY);
			if (this.hasTabAccess(MENU_CODE, TABS.Prac)) tabItems.push(TAB_NAMES.PRAC);
			if (this.hasTabAccess(MENU_CODE, TABS.CiziVykonySlevyKorekce)) tabItems.push(TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE);
			if (this.hasTabAccess(MENU_CODE, TABS.ZapujckyRef)) tabItems.push(TAB_NAMES.ZAPUJCKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Vydejky)) tabItems.push(TAB_NAMES.VYDEJKY);
			if (this.hasTabAccess(MENU_CODE, TABS.History)) tabItems.push(TAB_NAMES.HISTORY);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamky)) tabItems.push(TAB_NAMES.POZNAMKY);
			if (this.hasTabAccess(MENU_CODE, TABS.Zarazeni)) tabItems.push(TAB_NAMES.ZARAZENI);
			if (this.hasTabAccess(MENU_CODE, TABS.ZakazkyRef)) tabItems.push(TAB_NAMES.ZAKAZKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Doklady)) tabItems.push(TAB_NAMES.DOKLAD);
			if (this.hasTabAccess(MENU_CODE, TABS.OSC)) tabItems.push(TAB_NAMES.ZAKAZKY_OSC);

			return _.pick(TABS, tabItems);
		},
		isUserServiceAdvisorOrCre(): boolean {
			return this.pracovnik.PracovnikOzn === (UserRole.SERVICE_ADVISER) || this.pracovnik.PracovnikOzn === (UserRole.CRE);
		},
	},
});
